import { ActionReducerMap } from '@ngrx/store';
import { AppState } from './app.state';

import { authReducer } from './auth/auth.reducer';
import { catalogReducer } from './catalog/catalog.reducer';
import { cartReducer } from './cart/cart.reducer';
import { ordersReducer } from './orders/orders.reducer';
import { profileReducer } from './profile/profile.reducer';
import { stockReducer } from './stock/stock.reducer';

import * as authEffects from './auth/auth.effects';
import * as catalogEffects from './catalog/catalog.effects';
import * as cartEffects from './cart/cart.effects';
import * as ordersEffects from './orders/orders.effects';
import * as profileEffects from './profile/profile.effects';
import * as stockEffects from './stock/stock.effects';

/** Root reducer map wired into provideStore(). */
export const rootReducers: ActionReducerMap<AppState> = {
  auth: authReducer,
  catalog: catalogReducer,
  cart: cartReducer,
  orders: ordersReducer,
  profile: profileReducer,
  stock: stockReducer,
};

/** All functional effects, wired into provideEffects(). */
export const rootEffects = [
  authEffects,
  catalogEffects,
  cartEffects,
  ordersEffects,
  profileEffects,
  stockEffects,
];

// Public surface for feature code.
export type { AppState } from './app.state';
export { AuthActions } from './auth/auth.actions';
export { CatalogActions } from './catalog/catalog.actions';
export { CartActions } from './cart/cart.actions';
export { OrdersActions } from './orders/orders.actions';
export { ProfileActions } from './profile/profile.actions';
export { StockActions } from './stock/stock.actions';

export * from './auth/auth.selectors';
export * from './catalog/catalog.selectors';
export * from './cart/cart.selectors';
export * from './orders/orders.selectors';
export * from './profile/profile.selectors';
export * from './stock/stock.selectors';
export * from './inventory.selectors';
